import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { openPipelineEnquiryDialog } from 'src/app/modal/pipeline-enquiry/pipeline-enquiry.component';
import { CommonService } from 'src/app/core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { SearchCustData } from './searchCust';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { element } from 'protractor';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-pipeline-search',
  templateUrl: './pipeline-search.component.html',
  styleUrls: ['./pipeline-search.component.css']
})
export class PipelineSearchComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  custCode: string
  custMobile: string
  custName: string
  vehSalesEnqNo: string
  vehRegNo: string
  chassisNo: string
  startDate: string;
  endDate: string;
  spinner: boolean;
  modelName: string
  model= new FormControl();
  filteredOptionsModel: Observable<string[]>;
  ModelSuggestion: string[] = [];
  columnsToDisplay: string[] = ['customerName', 'customerCode', 'customerTelephone', 'registrationNo', 'vin', 'saleDate', 'vehicleModel']
  searchedCustomer: any
  showTable: boolean = false
  showEnquirybtn: boolean = false;
  pageLength = 0;
  pageSize: number;
  clickedRow: any;
  tableData: any;
  uniqueChassisArray: string[];
  selectedRowIndex: any;
  customerName = new FormControl();
  filteredOptions: Observable<string[]>;
  customerNameSuggestion: string[] = [];
  today: Date = new Date();
  responseData: any;
  constructor(private router: Router, public dialog: MatDialog, private fb: FormBuilder, private commonService: CommonService, private toastr: ToastrService, private datePipe: DatePipe) { }

  ngOnInit() {
    if (localStorage.getItem('pipSearchListPageSize') != null || localStorage.getItem('pipSearchListPageSize') != undefined) {
      let pagesize = Number(localStorage.getItem('pipSearchListPageSize'));
      this.pageSize = (pagesize && !Number.isNaN(pagesize)) ? pagesize : 50;
    } else {
      this.pageSize = 50;
    }
    this.filteredOptions = this.customerName.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
    this.commonService.customerNameSuggestionFilter().subscribe(res => {
      if (res['responseCode'] == 0) {
        res['responseData'].forEach(element => {
          this.customerNameSuggestion.push(element.customerName);
        })
      }
      else {
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });

    this.filteredOptionsModel = this.model.valueChanges.pipe(
      startWith(''),
      map(value => this._filterModel(value.trim()))
    );
    this.commonService.getModelSuggestionFilter().subscribe(res => {
      if (res['responseCode'] == 0) {
        res['responseData'].forEach(element => {
          this.ModelSuggestion.push(element.vehicleModel);
        })
      }
      else {
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  showEnquiryDialog() {
    openPipelineEnquiryDialog(this.dialog, this.clickedRow, this.uniqueChassisArray).subscribe(val => {
      this.selectedRowIndex = val;
    });
    this.uniqueChassisArray = [];
  }


  private _filter(value: string): string[] {
    if (value.length >= 3) {
      const filterValue = value.toLowerCase();
      return this.customerNameSuggestion.filter(option =>
        option.toLowerCase().startsWith(filterValue)
      );
    }
  }

  private _filterModel(value: string): string[] {
    if (value.length >= 2) {
      const filterValue = value.toLowerCase();
      return this.ModelSuggestion.filter(option =>
        option.toLowerCase().includes(filterValue)
      );
    }
  }

  applyFilter() {

    this.startDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
    this.endDate = this.datePipe.transform(this.endDate, "yyyy-MM-dd");
    this.custName = this.customerName.value;
    this.modelName = this.model.value;

    if (this.custCode == null) {
      this.custCode = "";
    }
    if (this.custMobile == null) {
      this.custMobile = "";
    }
    if (this.vehRegNo == null) {
      this.vehRegNo = "";
    }
    if (this.custName == null || this.custName == "") {
      this.custName = "";
    }
    if (this.chassisNo == null) {
      this.chassisNo = "";
    }
    if (this.startDate == null || this.startDate == "") {
      this.startDate = "";
    }
    if (this.endDate == null || this.endDate == "") {
      this.endDate = "";
    }
    if (this.modelName == null || this.modelName == "") {
      this.modelName = "";
    }
    this.spinner = true;

    this.commonService.pipelineSearchFilter(this.custCode, this.custMobile, this.vehRegNo, this.custName, this.chassisNo, this.startDate, this.endDate, this.modelName).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.spinner = false;
        this.showTable = true;
        this.searchedCustomer = new MatTableDataSource<SearchCustData>(res['responseData']);
        this.pageLength = res["responseData"].length;
        // this.sort.direction = '';
        this.searchedCustomer.sort = this.sort;
        this.searchedCustomer.sortingDataAccessor = (data, header) => data[header];
        this.searchedCustomer.paginator = this.paginator;
        this.tableData = res['responseData'];
      }
      else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");

    });
  }

  setPageData(event) {
    let size = event.pageSize.toString();
    localStorage.setItem('pipSearchListPageSize', size);
  }

  activeButton(): boolean {
    let flag = false;
    if (this.custCode != null && this.custCode.length != 0) {
      flag = true;
    } else if (this.customerName.value != null && this.customerName.value.length != 0) {
      flag = true;
    } else if (this.custMobile != null && this.custMobile.length != 0) {
      flag = true;
    } else if (this.vehSalesEnqNo != null && this.vehSalesEnqNo.length != 0) {
      flag = true;
    } else if (this.vehRegNo != null && this.vehRegNo.length != 0) {
      flag = true;
    } else if (this.chassisNo != null && this.chassisNo.length != 0) {
      flag = true;
    } else if ((this.startDate != null && this.startDate.length != 0) && (this.endDate != null && this.endDate.length != 0)) {
      flag = true;
    } else if (this.model.value != null && this.model.value.length != 0) {
      flag = true;
    }
    return flag;
  }

  createEnquiry(row) {
    let chassisArray: string[] = [];
    this.selectedRowIndex = row.id;
    this.clickedRow = row;
    this.tableData.forEach(element => {
      if (element.customerCode == row.customerCode) {
        chassisArray.push(element.vin);
        this.uniqueChassisArray = Array.from(new Set(chassisArray));

      }
    });

  }

  showEnquiryDialogueFilter() {
    this.commonService.enquiryDialogFilter().subscribe(res => {
      this.responseData = res;
      return this.responseData;
    })
  }

  clearFilter() {
    this.custCode = "";
    this.custMobile = "";
    this.vehRegNo = "";
    this.custName = "";
    this.chassisNo = "";
    this.startDate = "";
    this.endDate = "";
    this.modelName = "";
    this.vehSalesEnqNo = "";
    this.searchedCustomer = "";
  }
}
